import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, renderList as _renderList, renderSlot as _renderSlot } from "vue"
import _imports_0 from '@/img/chevronLeft.svg'
import _imports_1 from '@/img/chevronRight.svg'


const _hoisted_1 = { class: "calendar" }
const _hoisted_2 = {
  key: 0,
  class: "modeChanger"
}
const _hoisted_3 = { class: "navigatorContainer" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "navigatorTitle" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "weekDaysContainer"
}
const _hoisted_10 = {
  key: 2,
  class: "weekDaysContainer"
}
const _hoisted_11 = {
  class: "calendarDaysContainer",
  ref: "daysContainer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showNavigator)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.showModeChanger)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setMode('month'))),
                  class: _normalizeClass({ active: _ctx.mode == 'month' })
                }, "VISUALIZZA MESE", 2),
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setMode('week'))),
                  class: _normalizeClass({ active: _ctx.mode == 'week' })
                }, "VISUALIZZA SETTIMANA", 2)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "prev",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goPrev && _ctx.goPrev(...args)))
            }, _hoisted_5),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.navigatorTitle), 1),
            _createElementVNode("div", {
              class: "next",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goNext && _ctx.goNext(...args)))
            }, _hoisted_8)
          ])
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.mode == 'month')
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.originalWeekDays, (giorno, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "weekDay",
              key: i
            }, [
              _createElementVNode("b", null, _toDisplayString(giorno), 1)
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekDays, (giorno, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "weekDay",
              key: i
            }, [
              _createElementVNode("b", null, _toDisplayString(giorno), 1)
            ]))
          }), 128))
        ])),
    _createElementVNode("div", _hoisted_11, [
      _renderSlot(_ctx.$slots, "default", { days: _ctx.days })
    ], 512)
  ]))
}